import React from 'react';
import PropTypes from 'prop-types';
import styles from './wizard-button.module.scss';
import { useRouter } from 'next/router';
import { ctaEvents } from '@/lib/gtm';

const WizardButton = ({ text, ...props }) => {
	const className = (props.className ? props.className + ' ' : '') + styles.button;
	const router = useRouter();

	const path = props.diagnosisType !== 'potens' ? '/doktor' : '/';
	const ctaBtnAction = props.diagnosisType !== 'potens' ? text : 'TILLFÄLLIGT STÄNGT';

	return (
		<button
			className={className}
			onClick={() => {
				ctaEvents('list', props.diagnosisType, props.visitType === 'Revisit');
				sessionStorage.setItem('currentUrl', router.asPath);
				router.push({
					pathname: path,
					query: {
						diagnosisTypeOverride: props.diagnosisType,
						...(props.visitType === 'Revisit' ? { revisit: true } : null),
					},
				});
			}}
		>
			{ctaBtnAction}
		</button>
	);
};

WizardButton.propTypes = {
	text: PropTypes.string.isRequired,
};

export default WizardButton;
